import React, {
  useMemo,
  useRef,
  RefObject,
} from 'react';
import isNil from 'lodash/isNil';
import dayjs, {
  Dayjs,
} from 'utils/dayjs';
import useUrlSyncState from 'pages/Dashboard/hooks/useUrlSyncState';
import FilterProvider from 'core/Filters/context';
import {
  EncountersFilter,
} from 'core/Filters/types';
import {
  formatDateTimeOffset,
} from 'utils/date';
import PatientList from 'pages/Dashboard/pages/Encounters/pages/List/components/PatientList';
import {
  useUserSettings,
} from 'core/hooks';
import {
  EncounterViewModel,
} from 'dtos';
import ViewProvider from 'pages/Dashboard/contexts/viewContext';

export default function List() {
  const [date, setDate] = useUrlSyncState<Dayjs>(
    dayjs(),
    'date',
    (state: Dayjs) => state.format('YYYY-MM-DD'),
    (query: string) => (query ? dayjs(query) : dayjs()),
    'encounters-selected-date',
  );
  const formattedDate = useMemo(() => (
    formatDateTimeOffset((date ?? dayjs()).startOf('day'))
  ), [date]);
  const filterSlotRef = useRef<HTMLDivElement>(null) as RefObject<HTMLDivElement>;
  const { settings } = useUserSettings();

  const onDateChange = (date: Dayjs | null) => {
    if (dayjs?.isDayjs(date) && date?.isValid()) {
      setDate(date);
    } else if (!isNil(date)) {
      console.warn('[EncountersList] Ignoring unexpected date value.', date);
    }
  };

  return (
    <FilterProvider<EncountersFilter, EncounterViewModel>
      objectType="encounter"
      defaultValues={settings?.encounterFilters ?? {}}
      controlClassName="settings-button-select w-full"
      filtersSlot={filterSlotRef.current}
      dataParams={[formattedDate]}
    >
      <ViewProvider>
        <PatientList
          ref={filterSlotRef}
          date={date}
          setDate={onDateChange}
        />
      </ViewProvider>
    </FilterProvider>
  );
}
